/*
  KP: draws THE DELIVERY ESTIMATE on product pages. What it says is all in
  assets/kp-delivery-config.js; edit that file, not this one. Styles are in
  assets/kp-delivery.css.

  It fills every  <div class='delivery_date_shortcode'></div>  on the page (the block the
  "Estimated Delivery Date" app used to fill). If that app is still switched on (theme
  editor > App embeds), this does nothing and leaves the box to the app.

  LAYOUT (23 Oct 2026, second version):
      Delivery to United Kingdom                     Change
      Standard delivery                     29 Oct – 3 Nov
      Express delivery                         27 – 30 Oct   (only where the rule has express days)
      ------------------------------------------------------
      [van] Free delivery over £65      (from window.KP_FREESHIP, if the country has it)
      small grey note                     (the rule's note, if any)
      Shipping & returns                  (opens a pop-up with cfg.policies' text)
  No price for Express.

  PRODUCT GROUP. A rule has  groups: [...]  and only applies to products in one of those
  groups. The group comes from the product's type and title (window.ShopifyAnalytics):
    print  product type Art Prints, Framed Prints or Wall Hangings
    mug    product type Mugs
    woyc   title contains Power Bank, Water Bottle, Shell Only or
           "MagSafe Ring (Tough Case Upgrade)"
    case   title contains Phone Case
    tech   anything else

  PRINTS AND MUGS OFFER. On print and mug pages it also adds "15% off when you buy 3 or
  more prints or mugs" under the price (priceOffer below).

  SPOKS BADGE. On phones it hides the Spoks 10% badge while the sticky Add to Cart bar
  shows (spoksBadge below).

  THE NOTE ON THE ORDER. It also puts the two standard dates on the product being added to
  the basket, as a line called "Estimated Delivery" (for example "14th Oct - 17th Oct").
  orderNote: '...' in the config renames it; orderNote: '' switches it off.
*/
(function () {
  'use strict';

  var cfg = window.KP_DELIVERY;
  if (!cfg || !cfg.rules) return;

  var page = window.KP_DELIVERY_PAGE || {};
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SHORT_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var STORE_KEY = 'kp-delivery-country';
  var NOTE_NAME = cfg.orderNote === undefined ? 'Estimated Delivery' : cfg.orderNote;

  function productGroup() {
    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) || {};
    var type = meta.type || '';
    var name = (meta.variants && meta.variants[0] && meta.variants[0].name) || document.title || '';
    if (/^(Art Prints|Framed Prints|Wall Hangings)$/i.test(type)) return 'print';
    if (/^Mugs$/i.test(type)) return 'mug';
    if (/Power Bank|Water Bottle|Shell Only|MagSafe Ring \(Tough Case Upgrade\)/i.test(name)) return 'woyc';
    if (/Phone Case/i.test(name)) return 'case';
    return 'tech';
  }
  var GROUP = productGroup();

  function two(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // Today's date where the shop is (held at midnight UTC so adding days is plain arithmetic).
  function today() {
    var now = new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: cfg.timeZone || 'Europe/London',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }).formatToParts(now);
      var got = {};
      for (var i = 0; i < parts.length; i++) got[parts[i].type] = parseInt(parts[i].value, 10);
      if (got.year && got.month && got.day) return new Date(Date.UTC(got.year, got.month - 1, got.day));
    } catch (e) {}
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  }

  function isSkipped(date) {
    var skip = cfg.skipDays || [];
    if (skip.indexOf(DAY_NAMES[date.getUTCDay()]) !== -1) return true;
    var holidays = cfg.holidays || [];
    var monthDay = two(date.getUTCMonth() + 1) + '-' + two(date.getUTCDate());
    return holidays.indexOf(monthDay) !== -1 || holidays.indexOf(date.getUTCFullYear() + '-' + monthDay) !== -1;
  }

  // The date "count" days from today, not counting skipped days.
  function dateAfter(count) {
    var date = today();
    var counted = 0;
    var guard = 0;
    while (counted < count && guard < 400) {
      date = new Date(date.getTime() + 86400000);
      if (!isSkipped(date)) counted++;
      guard++;
    }
    return date;
  }

  function ordinal(n) {
    var tens = n % 100;
    if (tens >= 11 && tens <= 13) return n + 'th';
    return n + (['th', 'st', 'nd', 'rd'][n % 10] || 'th');
  }

  // "14th Oct", kept on the order.
  function nice(date) {
    return ordinal(date.getUTCDate()) + ' ' + MONTHS[date.getUTCMonth()];
  }

  // "Thu 29 Oct", shown on the page.
  function shown(date) {
    return SHORT_DAYS[date.getUTCDay()] + ' ' + date.getUTCDate() + ' ' + MONTHS[date.getUTCMonth()];
  }

  function applies(rule) {
    if (rule.groups && rule.groups.indexOf(GROUP) === -1) return false;
    if (!rule.collections) return true;
    var mine = page.collections || [];
    for (var i = 0; i < mine.length; i++) {
      if (rule.collections.indexOf(Number(mine[i])) !== -1) return true;
    }
    return false;
  }

  function myRules() {
    var list = [];
    for (var i = 0; i < cfg.rules.length; i++) {
      if (applies(cfg.rules[i])) list.push(cfg.rules[i]);
    }
    return list;
  }

  function ruleFor(country, rules) {
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].countries.indexOf(country) !== -1) return rules[i];
    }
    return null;
  }

  function nameOf(code) {
    return (cfg.countryNames && cfg.countryNames[code]) || code;
  }

  function remembered() {
    try {
      return window.localStorage.getItem(STORE_KEY);
    } catch (e) {
      return null;
    }
  }

  function remember(code) {
    try {
      window.localStorage.setItem(STORE_KEY, code);
    } catch (e) {}
  }

  function datesText(rule) {
    return nice(dateAfter(rule.days[0])) + ' - ' + nice(dateAfter(rule.days[1]));
  }

  function setNote(holder, text) {
    if (!NOTE_NAME) return;
    var area = holder.closest('.shopify-section') || document;
    var forms = area.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var input = forms[i].querySelector('input.kp-delivery__note');
      if (!text) {
        if (input) input.parentNode.removeChild(input);
        continue;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + NOTE_NAME + ']';
        input.className = 'kp-delivery__note';
        forms[i].appendChild(input);
      }
      input.value = text;
    }
  }

  // A range of working days from today, "27 – 30 Oct" or "30 Oct – 3 Nov".
  function range(days) {
    var a = dateAfter(days[0]);
    var b = dateAfter(days[1]);
    var first = a.getUTCMonth() === b.getUTCMonth() ? String(a.getUTCDate()) : a.getUTCDate() + ' ' + MONTHS[a.getUTCMonth()];
    return first + ' – ' + b.getUTCDate() + ' ' + MONTHS[b.getUTCMonth()];
  }

  var TRUCK =
    '<svg class="kp-delivery__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M2 6.5h11v9.5H2z"/><path d="M13 9.5h4.2l3.3 3.4V16H13z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';

  function bodyHtml(rule, country) {
    var html =
      '<div class="kp-delivery__row"><span class="kp-delivery__label">Standard delivery</span>' +
      '<span class="kp-delivery__value">' + range(rule.days) + '</span></div>';
    if (rule.express) {
      html +=
        '<div class="kp-delivery__row"><span class="kp-delivery__label">Express delivery</span>' +
        '<span class="kp-delivery__value">' + range(rule.express) + '</span></div>';
    }
    var free = (window.KP_FREESHIP || {})[country];
    var below = '';
    if (free) below += '<p class="kp-delivery__free">' + TRUCK + '<span>Free delivery over ' + free + '</span></p>';
    if (rule.note) below += '<p class="kp-delivery__small">' + rule.note + '</p>';
    if (cfg.summary) {
      below += '<a class="kp-delivery__policy" href="/policies/shipping-policy" role="button">Delivery &amp; returns</a>';
    } else if (cfg.policies && cfg.policies.length) {
      below += '<a class="kp-delivery__policy" href="' + cfg.policies[0] + '">Shipping &amp; returns</a>';
    }
    if (below) html += '<div class="kp-delivery__below">' + below + '</div>';
    return html;
  }

  function draw(holder) {
    var rules = myRules();

    var codes = [];
    for (var i = 0; i < rules.length; i++) {
      for (var j = 0; j < rules[i].countries.length; j++) {
        if (codes.indexOf(rules[i].countries[j]) === -1) codes.push(rules[i].countries[j]);
      }
    }
    if (!codes.length) return;
    codes.sort(function (a, b) {
      return nameOf(a).localeCompare(nameOf(b));
    });

    var start = remembered();
    if (codes.indexOf(start) === -1) start = page.country;
    if (codes.indexOf(start) === -1) start = cfg.fallbackCountry;
    if (codes.indexOf(start) === -1) start = codes[0];

    var options = '';
    for (var k = 0; k < codes.length; k++) {
      options +=
        '<option value="' + codes[k] + '"' + (codes[k] === start ? ' selected' : '') + '>' + nameOf(codes[k]) + '</option>';
    }

    // The select sits invisibly over the whole "Delivery to United Kingdom    Change" line,
    // so tapping anywhere on it opens the country list (the phone's own picker on mobile).
    holder.innerHTML =
      '<div class="kp-delivery">' +
      '<div class="kp-delivery__to">' +
      '<span>Delivery to <span class="kp-delivery__name"></span></span>' +
      '<u class="kp-delivery__change" aria-hidden="true">Change</u>' +
      '<select class="kp-delivery__country" aria-label="Change delivery country">' + options + '</select>' +
      '</div>' +
      '<div class="kp-delivery__body" aria-live="polite"></div>' +
      '</div>';
    holder.kpDelivery = true;

    var select = holder.querySelector('.kp-delivery__country');
    var name = holder.querySelector('.kp-delivery__name');
    var body = holder.querySelector('.kp-delivery__body');
    var show = function () {
      var rule = ruleFor(select.value, rules);
      name.textContent = nameOf(select.value);
      body.innerHTML = rule ? bodyHtml(rule, select.value) : '';
      setNote(holder, rule ? datesText(rule) : '');
      if (cfg.summary) deliveryDropdown(holder, rule, select.value);
    };
    select.addEventListener('change', function () {
      remember(select.value);
      show();
    });
    body.addEventListener('click', function (event) {
      if (!event.target.closest('.kp-delivery__policy')) return;
      event.preventDefault();
      if (cfg.summary) openSummary(ruleFor(select.value, rules), select.value);
      else openPolicies(event.target.closest('.kp-delivery__policy'));
    });
    // Used by shippingLink() below: opens the pop-up for the country picked in this box.
    holder.kpOpenSummary = function () {
      openSummary(ruleFor(select.value, rules), select.value);
    };
    show();

    var area = holder.closest('.shopify-section');
    if (area) {
      area.addEventListener('change', function (event) {
        if (event.target === select) return;
        setTimeout(function () {
          var rule = ruleFor(select.value, rules);
          setNote(holder, rule ? datesText(rule) : '');
        }, 300);
      });
    }
  }

  // THE "SHIPPING & RETURNS" POP-UP. Built once, on first tap: a <dialog> with the text of
  // each page in cfg.policies (Shopify's policy pages, .shopify-policy__body). If the pages
  // cannot be loaded, the link just opens the shipping policy page.
  var dialog = null;

  function openPolicies(link) {
    if (!window.HTMLDialogElement || !window.fetch || !window.DOMParser) {
      window.location.href = link.href;
      return;
    }
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'kp-policy';
      dialog.setAttribute('aria-label', 'Shipping and returns');
      dialog.innerHTML =
        '<div class="kp-policy__head"><span>Shipping &amp; returns</span>' +
        '<button type="button" class="kp-policy__close" aria-label="Close">×</button></div>' +
        '<div class="kp-policy__body"><p>Loading…</p></div>';
      document.body.appendChild(dialog);
      dialog.querySelector('.kp-policy__close').addEventListener('click', function () {
        dialog.close();
      });
      // Tapping the dark area outside the box closes it.
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      Promise.all(
        cfg.policies.map(function (url) {
          return fetch(url).then(function (response) {
            if (!response.ok) throw new Error(url);
            return response.text();
          });
        })
      )
        .then(function (pages) {
          var html = '';
          pages.forEach(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var title = doc.querySelector('.shopify-policy__title');
            var part = doc.querySelector('.shopify-policy__body');
            if (!part) return;
            html += '<section>' + (title ? '<h3>' + title.textContent.trim() + '</h3>' : '') + part.innerHTML + '</section>';
          });
          if (!html) throw new Error('empty');
          dialog.querySelector('.kp-policy__body').innerHTML = html;
        })
        .catch(function () {
          dialog.close();
          dialog.parentNode.removeChild(dialog);
          dialog = null;
          window.location.href = link.href;
        });
    }
    dialog.showModal();
  }

  // THE "DELIVERY & RETURNS" POP-UP (25 Oct 2026, Sana: a small accurate summary instead of
  // the full policies). Built from the same rule as the box, so it always says the same days.
  // The returns part follows the refund policy (Shopify admin > Settings > Policies).
  var summaryBox = null;

  // The delivery part of the summary, for the pop-up and for the product page's own
  // "Delivery" dropdown (deliveryDropdown below), so both always say the same.
  function deliveryHtml(rule, country) {
    var free = (window.KP_FREESHIP || {})[country];
    var span = function (d) { return d[0] + '–' + d[1] + ' working days'; };
    return (
      '<p>Everything is made to order. These times include making your item.</p>' +
      '<ul>' +
      '<li><b>Standard:</b> ' + span(rule.days) + ' (' + range(rule.days) + ')</li>' +
      (rule.express ? '<li><b>Express:</b> ' + span(rule.express) + ' (' + range(rule.express) + '). The price is shown at checkout.</li>' : '') +
      (free ? '<li>Free standard delivery on orders over ' + free + '.</li>' : '') +
      (rule.note ? '<li>' + rule.note + '.</li>' : '') +
      '</ul>' +
      '<p>We email you as soon as your order ships. Items made in different places, like prints, mugs and power banks, can arrive in separate parcels.</p>'
    );
  }

  // THE PRODUCT PAGE'S DELIVERY DROPDOWN (25 Oct 2026, Sana: all product types). Its old
  // hand-typed text is replaced with the same summary as the pop-up, for the country picked
  // in the delivery box, and it updates when the country is changed. The templates call it
  // different things: "Delivery" (phone cases, prints, mugs), "Shipping & Delivery"
  // (AirPods, iPad, wallets, ring holders, power banks, clear cases) and "Turnaround Time"
  // (the default template: bottles, straps, screen protectors, the MagSafe ring upgrade).
  // All are renamed "Delivery".
  var DROPDOWN_LABEL = /^\s*(delivery|shipping\s*(&|&amp;|and)?\s*delivery|turnaround\s*time)\s*$/i;
  function deliveryDropdown(holder, rule, country) {
    var area = (holder && holder.closest('.shopify-section')) || document;
    var labels = area.querySelectorAll('.accordion__label');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].closest('.quick-view, [data-quick-view]')) continue;
      if (!labels[i].kpDropdown && !DROPDOWN_LABEL.test(labels[i].textContent)) continue;
      var box = labels[i].parentNode.querySelector('.accordion__content');
      if (!box || !rule) continue;
      if (!labels[i].kpDropdown) {
        labels[i].kpDropdown = true;
        renameLabel(labels[i]);
      }
      box.innerHTML =
        '<p><b>Delivery to ' + nameOf(country) + '</b></p>' +
        deliveryHtml(rule, country) +
        '<p><a href="/policies/shipping-policy" class="kp-delivery__full">Full shipping policy</a></p>';
    }
  }

  // Changes only the label's words, keeping the theme's +/- icon next to them.
  function renameLabel(label) {
    var walk = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walk.nextNode())) {
      if (!node.nodeValue.trim()) continue;
      var upper = node.nodeValue === node.nodeValue.toUpperCase();
      node.nodeValue = node.nodeValue.replace(/\S[\s\S]*\S|\S/, upper ? 'DELIVERY' : 'Delivery');
      return;
    }
  }

  // The country to show when there is no delivery box to pick one in: the one picked
  // before, else the shopper's own, else the UK.
  function startCountry(rules) {
    var codes = [];
    for (var i = 0; i < rules.length; i++) codes = codes.concat(rules[i].countries);
    var tries = [remembered(), page.country, cfg.fallbackCountry];
    for (var j = 0; j < tries.length; j++) {
      if (tries[j] && codes.indexOf(tries[j]) !== -1) return tries[j];
    }
    return codes[0];
  }

  // Pages without a delivery box (mugs, bottles, straps, screen protectors, the ring
  // upgrade): the dropdown and the pop-up still use the same rules.
  function noBox() {
    var rules = myRules();
    if (!rules.length) return;
    var country = startCountry(rules);
    deliveryDropdown(null, ruleFor(country, rules), country);
    noBoxSummary = function () {
      openSummary(ruleFor(country, rules), country);
    };
  }
  var noBoxSummary = null;

  function openSummary(rule, country) {
    if (!rule) return;
    var html =
      '<h3>Delivery to ' + nameOf(country) + '</h3>' +
      deliveryHtml(rule, country) +
      '<h3>Returns</h3>' +
      '<ul>' +
      '<li>Changed your mind? Request a return within 30 days of delivery by emailing <a href="mailto:help@kinderplanetcompany.com">help@kinderplanetcompany.com</a>. Items must be unused and in their original packaging. Return postage is paid by you.</li>' +
      '<li>Personalised items can’t be returned.</li>' +
      '<li>Damaged, faulty or the wrong item? Email us a photo and we’ll put it right.</li>' +
      '</ul>' +
      '<p class="kp-policy__links"><a href="/policies/shipping-policy">Full shipping policy</a> · <a href="/policies/refund-policy">Full returns policy</a></p>';
    if (!window.HTMLDialogElement) {
      window.location.href = '/policies/shipping-policy';
      return;
    }
    if (!summaryBox) {
      summaryBox = document.createElement('dialog');
      summaryBox.className = 'kp-policy';
      summaryBox.setAttribute('aria-label', 'Delivery and returns');
      summaryBox.innerHTML =
        '<div class="kp-policy__head"><span>Delivery &amp; returns</span>' +
        '<button type="button" class="kp-policy__close" aria-label="Close">×</button></div>' +
        '<div class="kp-policy__body"></div>';
      document.body.appendChild(summaryBox);
      summaryBox.querySelector('.kp-policy__close').addEventListener('click', function () {
        summaryBox.close();
      });
      summaryBox.addEventListener('click', function (event) {
        if (event.target === summaryBox) summaryBox.close();
      });
    }
    summaryBox.querySelector('.kp-policy__body').innerHTML = html;
    summaryBox.showModal();
  }

  // The prints and mugs offer, as a small line under the price (23 Oct 2026; it used to be
  // in the delivery box). Matches the BUNDLEUP automatic discount.
  function priceOffer() {
    if (GROUP !== 'print' && GROUP !== 'mug') return;
    var spots = document.querySelectorAll('.product__price-and-ratings, .product__price-block');
    for (var i = 0; i < spots.length; i++) {
      if (spots[i].closest('.quick-view, [data-quick-view]')) continue;
      var next = spots[i].nextElementSibling;
      if (next && next.className === 'kp-price-offer') continue;
      var line = document.createElement('p');
      line.className = 'kp-price-offer';
      line.textContent = '15% off when you buy 3 or more prints or mugs';
      spots[i].parentNode.insertBefore(line, spots[i].nextSibling);
    }
  }

  // On phones, hide the Spoks "10% off" badge while the sticky Add to Cart bar is showing,
  // so the two do not sit on top of each other (23 Oct 2026). Spoks draws inside a shadow
  // root on a <div class="needsclick"> at the end of the page; only its small fixed pieces
  // (the badge) are hidden, never a full-screen popup.
  function spoksBadge() {
    var bar = document.querySelector('.kp-sticky-atc');
    if (!bar || bar.kpWatch || !window.MutationObserver) return;
    bar.kpWatch = true;
    var update = function () {
      var hide = bar.classList.contains('is-visible') && window.innerWidth < 720;
      var hosts = document.querySelectorAll('body > div.needsclick');
      for (var i = 0; i < hosts.length; i++) {
        var root = hosts[i].shadowRoot;
        if (!root) continue;
        var all = root.querySelectorAll('*');
        for (var j = 0; j < all.length; j++) {
          var el = all[j];
          if (el.kpHidden && !hide) {
            el.style.visibility = '';
            el.kpHidden = false;
            continue;
          }
          if (!hide || el.kpHidden) continue;
          var box = el.getBoundingClientRect();
          if (box.height && box.height < 160 && box.width < 320 && getComputedStyle(el).position === 'fixed') {
            el.style.visibility = 'hidden';
            el.kpHidden = true;
          }
        }
      }
    };
    new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['class'] });
    // Spoks can draw its badge after the bar is already showing.
    setInterval(update, 1500);
    window.addEventListener('resize', update);
  }

  // The "Shipping" link in "Tax included. Shipping calculated at checkout." under the price
  // opens the Delivery & returns pop-up instead of leaving the product page (25 Oct 2026, Sana).
  // Links in the footer and inside the pop-up itself still go to the policy page.
  var linkWatch = false;
  function shippingLink() {
    if (linkWatch || !cfg.summary) return;
    linkWatch = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href*="/policies/shipping-policy"]');
      if (!link || link.classList.contains('kp-delivery__policy') || link.classList.contains('kp-delivery__full')) return;
      if (link.closest('.kp-policy, footer, .footer, .shopify-section-group-footer-group')) return;
      var holder = document.querySelector('.delivery_date_shortcode');
      var open = (holder && holder.kpOpenSummary) || noBoxSummary;
      if (!open) return;
      event.preventDefault();
      open();
    });
  }

  function run() {
    priceOffer();
    spoksBadge();
    shippingLink();
    if (window.sb_edd_options) return;
    var holders = document.querySelectorAll('.delivery_date_shortcode');
    for (var i = 0; i < holders.length; i++) {
      if (!holders[i].querySelector('.kp-delivery')) draw(holders[i]);
    }
    if (cfg.summary && !holders.length) noBox();
  }

  // For checking by hand: KP_DELIVERY.draw(element); KP_DELIVERY.group is this page's group.
  cfg.draw = draw;
  cfg.group = GROUP;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
